/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/**
 * global jQuery
 * Compat shim for Selectize
 * which relies on some jQuery utility methods that were removed in jQuery 4.
 * This file restores those methods to ensure Selectize continues to work with jQuery 4.
 */
import $ from 'jquery';

if (!window.__selectizeJq4CompatApplied) {
  $.trim = $.trim || ((value) => (value == null ? '' : String(value).trim()));
  $.isArray = $.isArray || Array.isArray;
  $.isFunction = $.isFunction || ((fn) => typeof fn === 'function');
  $.isNumeric = $.isNumeric || ((value) => value !== null && value !== '' && !Number.isNaN(Number(value)));
  $.parseJSON = $.parseJSON || function parseJSONCompat(value) {
    if (value == null || value === '') {
      return null;
    }
    return JSON.parse(String(value));
  };

  $.fn.size = $.fn.size || function size() { return this.length; };
  if (!$.fn.andSelf && $.fn.addBack) {
    $.fn.andSelf = $.fn.addBack;
  }

  window.__selectizeJq4CompatApplied = true;
}

const jQueryMajorVersion = Number.parseInt(($.fn.jquery || '0').split('.')[0], 10);

/**
 * jQuery 4 no longer auto-evaluates script responses for general AJAX requests.
 * This shim restores legacy behavior relied upon by jquery-ujs remote forms/links
 * and plain $.ajax calls that expect server-rendered *.js.erb to execute.
 */
if (jQueryMajorVersion >= 4 && !window.__jq4AjaxScriptEvalCompatApplied) {
  window.jq4EvaluateScriptResponse = (responseText) => {
    if (!responseText || typeof responseText !== 'string') return;
    $.globalEval(responseText);
  };

  const isJavaScriptResponse = (xhr) => (
    ((xhr && xhr.getResponseHeader && xhr.getResponseHeader('content-type')) || '').
      toLowerCase().
      includes('javascript')
  );

  $(document).on('ajaxSuccess', (_event, xhr, settings) => {
    if (!xhr || xhr.__jq4ScriptEvaluated) return;
    if (!isJavaScriptResponse(xhr)) return;
    if (((settings && settings.dataType) || '').toLowerCase() === 'script') return;

    const { responseText } = xhr;
    if (!responseText) return;

    xhr.__jq4ScriptEvaluated = true;
    window.jq4EvaluateScriptResponse(responseText);
  });

  $(document).on('ajax:success', 'form[data-remote=true], a[data-remote=true]', (_event, data, _status, xhr) => {
    if (!xhr || xhr.__jq4ScriptEvaluated) return;
    if (!isJavaScriptResponse(xhr)) return;
    if (!data) return;

    xhr.__jq4ScriptEvaluated = true;
    window.jq4EvaluateScriptResponse(data);
  });

  window.__jq4AjaxScriptEvalCompatApplied = true;
}
